import React, { PropsWithChildren, useImperativeHandle, useRef } from 'react';
import { PlacesType, Tooltip, TooltipRefProps } from 'react-tooltip';
import CompanyHotelSettingsCalendarDayPopupTriggerType
	from '@app/model/company_hotel/settings/CompanyHotelSettingsCalendarDayPopupTriggerType';
import { useSelectedCompanyHotel } from '@app/site/secured/rateshopper/rates/provider/useSelectedCompanyHotel';

export const MarketStateSnapshotCalendarDayTooltip: React.FunctionComponent<PropsWithChildren<{
	id: string,
	place?: PlacesType,
	disabled?: boolean,
	ref: any
}>> = React.forwardRef(({ id, place = 'right', disabled = false, children }, ref: React.Ref<any>) => {
	const tooltip = useRef<TooltipRefProps>(null);
	const {companyHotel} = useSelectedCompanyHotel();

	useImperativeHandle(ref, () => {
		return {
			isOpen: tooltip.current!.isOpen,
			open: () => tooltip.current!.open({ anchorSelect: `[data-tooltip-id="${id}"]` }),
			close: () => tooltip.current!.close(),
		};
	});

	const isClickable = companyHotel.settings.calendar.calendarDayPopupTriggerType === CompanyHotelSettingsCalendarDayPopupTriggerType.ON_CLICK;

	return <Tooltip id={id}
									ref={tooltip}
									place={place}
									offset={14}
									isOpen={disabled ? false : undefined}
									openOnClick={isClickable && !disabled}
									clickable={isClickable && !disabled}
									opacity={1}
									noArrow={true}
									globalCloseEvents={{
										escape: true,
										clickOutsideAnchor: true,
									}}
									className="max-xl:!fixed max-xl:!left-4 max-xl:!top-4 !w-[calc(100vw-32px)] max-h-[calc(100dvh-32px)] overflow-y-auto rounded-lg xl:!w-auto xl:max-h-none xl:max-w-4xl z-40 bg-white shadow-2xl ring-1 ring-black ring-opacity-5"
									style={{
										backgroundColor: 'white',
										padding: '8px',
									}}>
		{children}
	</Tooltip>;
});
